import context, { ServiceType } from '@truckdown/systems';
import { defineComponent, ref, Ref, computed, onMounted, watch } from 'vue';
import { BannerModel, BannerStatus } from '@truckdown/locations';
import { ILookupService, ServiceModel } from '@truckdown/systems';

import banner from "./Banner/Banner.vue";
import editBanner from './EditBanner/EditBanner.vue';
import { showMessage } from '../Utilities/utilities';


interface IProps {
    banners: BannerModel[];
}

interface IData {
    allServices: Ref<ServiceModel[]>,
    servicesDisplayNumber: Ref<number>,
    showAdd: Ref<boolean>,
    allBanners: Ref<BannerModel[]>

}

const getData = function (props: IProps): IData {
    return {
        allServices: ref<ServiceModel[]>([]),
        servicesDisplayNumber: ref<number>(5),
        showAdd: ref<boolean>(false),
        allBanners: ref<BannerModel[]>(props.banners)
    }
}

const getMethods = function (props: IProps, data: IData, ctx: any) {

    const updateBanners = function (updatedBanner: BannerModel) {
        const index = data.allBanners.value.findIndex(b => b.id === updatedBanner.id);

        if (index !== -1) {
            if (updatedBanner.status === BannerStatus.Inactive) {
                data.allBanners.value.splice(index, 1);
            } else {
                data.allBanners.value[index] = { ...updatedBanner };
            }
        } else if (updatedBanner.status !== BannerStatus.Inactive) {
            data.allBanners.value.push(updatedBanner);
        }
    }
    return {
        openAddModal: function () {
            data.showAdd.value = true;
        },
        submitEdit: function (updatedBanner: BannerModel) {
            data.showAdd.value = false;
            updateBanners(updatedBanner);
            showMessage("The banner has been added.", "success", true, true);
        },
        cancelAdd: function () {
            data.showAdd.value = false;
        }, 
        updateBanner: function (updatedBanner: BannerModel) {
            updateBanners(updatedBanner);
        }
    }
}

const setServices = async function (data: IData) {
    try {
        const service = await context.getService<ILookupService>('ILookupService');
        const result = await service.getServices({
            types: [ServiceType.Service],
            sites: ['truckdown']
        });
        if (result !== null) {
            data.allServices.value = result;
        }
    } catch (reason) {
        console.error('Error getting services', reason);
    }
};

export default defineComponent({
    name: "banner-list",
    emits: [],
    components: {
        "banner": banner,
        "edit-banner": editBanner
    },
    props: {
        banners: {
            type: Array as () => BannerModel[],
            required: true
        },
        accountId: {
            type: String,
            required: true
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    setup: function (props, ctx) {
        let data = getData(props);
        let methods = getMethods(props, data, ctx);

        onMounted(async () => {
            await setServices(data);
        });

        return {
            ...data,
            ...methods
        };
    }
});